import * as React from "react";
import { createContext, useContext, useState, useMemo, useCallback } from "react";
import Cursor from "./Cursor.js";

const CursorContext = createContext(null);

// Safe default so components can call useCursor() even if rendered
// outside a provider (e.g. isolated tests) without crashing.
const NOOP_CURSOR = {
  setCursor: () => {},
  onProjectEnter: () => {},
  onContactEnter: () => {},
  onPhotoEnter: () => {},
  onLinkEnter: () => {},
  onLeave: () => {},
};

export function useCursor() {
  return useContext(CursorContext) ?? NOOP_CURSOR;
}

export function CursorProvider({ children }) {
  const [cursor, setCursorState] = useState({ variant: "default", text: "" });

  const setCursor = useCallback((variant = "default", text = "") => {
    setCursorState({ variant, text });
  }, []);

  const api = useMemo(
    () => ({
      setCursor,
      onProjectEnter: () => setCursor("project", "View"),
      onContactEnter: () => setCursor("contact", "👋"),
      onPhotoEnter: () => setCursor("contact", "❤️"),
      onLinkEnter: () => setCursor("link", ""),
      onLeave: () => setCursor("default", ""),
    }),
    [setCursor]
  );

  return (
    <CursorContext.Provider value={api}>
      {children}
      <Cursor cursorText={cursor.text} cursorVariant={cursor.variant} />
    </CursorContext.Provider>
  );
}

export default CursorProvider;
